import React from "react";
import { inject } from "mobx-react";
import {
  Button,
  Row,
  Col
} from "reactstrap";

import PagesComponent from "./PagesTabComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import PaginationComponent from "~/components/PaginationComponent";
import PopupDevices from "~/components/PopupDevicesComponent";
import JSZip from "jszip";

import { PAGE_TYPE, PAGES_PAGE_TAB, URL_APP_APP_BASE_PATH, URL_APP_BASE_PATH } from "../../../configs/constants";
import { getVarFromUrl } from "../../../helpers/utils";
import { saveAs } from "file-saver";

@inject("PageStore", "DeviceStore", "UserStore", "ImageStore", "HangtagStore")
class PagesContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      pages: [],
    };
  }

  async componentDidMount() {
    this.getPages();
  }

  getPages = async (skip) => {
    this.setState({
      isLoading: true,
    });
    if (skip === undefined) skip = 0;

    const { PageStore } = this.props;
    const deviceId = getVarFromUrl("deviceId");
    const data = await PageStore.getPages(deviceId,skip);
    let pagesAux = [];
    let countItems = 0;
    let currentPage = 1;
    let countPages = 1;
    if (data && data !== "" && data.pages.length > 0) {
      pagesAux = data.pages;
      countItems = data.countItems;
      countPages = data.countPages;
    }  
    this.setState({
      pages: pagesAux,
      currentPage: currentPage,
      countItems: countItems,
      countPages: countPages,
      skip: skip,
      isLoading: false,
    });
  };

  onClick = (pageId) => {
    const { history, PageStore } = this.props;
    PageStore.setPageId(pageId);
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${pageId}&tab=${PAGES_PAGE_TAB}`);
  };

  onDelete = async (pageId) => {
    this.setState({
      isLoading: true
    });

    const { PageStore } = this.props;

    const result = await PageStore.delete(pageId);
    if (result === "true" || result === true){
      AlertComponent.success("Página removida com sucesso");
      this.getPages();
    } else {
      AlertComponent.error("Falha ao remover página");
    }

    this.setState({
      isLoading: false
    });
  };

  handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const { PageStore } = this.props;
    const { pages } = this.state;
    const items = Array.from(pages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    PageStore.reorder(items);

    this.setState({
      pages: items
    });
  };

  onPageChange = async (currentPage) => {  
    const skip = (currentPage - 1) * 100;
    await this.getPages(skip);
    this.setState({
      currentPage: currentPage,
      skip: skip
    });
  };

  onView = async (page) => {
    window.open(URL_APP_APP_BASE_PATH + "?pageView=" + page.pageId);
  }

  onDownload = async (page) => {
    try {
      this.setState({
        isLoading: true
      });

      const { ImageStore, HangtagStore } = this.props;
      const images = await ImageStore.getImages(page.pageId, PAGE_TYPE.folder, "", 0); 
      const tags = await HangtagStore.getHangtagsByPage(page.deviceId, page.pageId, "", 0);
      if (page.type === PAGE_TYPE.folder && 
          images !== null && 
          images.images !== null && 
          images.images.length > 0 && 
          images.images.length > page.itemsCount){ 

        await this.downloadAllAsZip(images.images, page);
      }
      else if ((page.type === PAGE_TYPE.tags || page.type === PAGE_TYPE.list || page.type === PAGE_TYPE.table) && 
          tags !== null && 
          tags.tags !== null && 
          tags.tags.length > 0 && 
          tags.tags.length > page.itemsCount){ 

        await this.downloadAllAsZip(tags.tags, page);
      }
      else {
        const response = await fetch(URL_APP_BASE_PATH.replace("api","view/page/") + page.pageId, {
          method: "GET",
        });

        if (!response.ok) throw new Error("Erro ao buscar imagem");
        await this.downloadItem(response, page.description ?? "página");
      }
    
      this.setState({
        isLoading: false
      });
    } catch (err) {
      console.error("Erro no download:", err);
    }
  };

  downloadItem = async(response, name) =>{
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = name + ".jpeg";
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  }

  downloadAllAsZip = async(list, page) => {
    try {
      const zip = new JSZip();
      let index = Math.ceil(list.length / page.itemsCount);
      let currentIndex = 0;

      let baseUrl = URL_APP_BASE_PATH.replace("api", "view/page/") + page.pageId;

      for (let i = 0; i < index; i++) {
        const response = await fetch(baseUrl + "?startIndex=" + currentIndex, {
          method: "GET",
        });

        if (!response.ok) throw new Error("Erro ao buscar imagem");

        const blob = await response.blob();

        let description = (page.description ?? "página") + "_" + (i + 1);

        zip.file(description + ".jpeg", blob);        
        currentIndex = (currentIndex + page.itemsCount);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, (page.description ?? "página") + ".zip");
    } catch (err) {
      console.error("Erro no download:", err);
    }
  }

  onDuplicate = async (page) => {
    try {
      const { DeviceStore, PageStore } = this.props;
      
      let device = await DeviceStore.getDevice();
      const devices = await DeviceStore.getDevices(device.organizationId, 0);

      PopupDevices.show(devices.devices, (device) => {
        AlertComponent.dialog(
          `Irá duplicar a página ${page.description} para o dispositivo ${device.title}.`,
          () => {},
          async () => {
            this.setState({ isLoading: true });
            await PageStore.duplicate(page.pageId, device.deviceId);
            AlertComponent.success("Página duplicada com sucesso");
            this.setState({ isLoading: false });
            this.getPages();            
          }
        );
      });
    } catch (err) {
      console.error("Erro de duplicação:", err);
    }
  };


  render() {
    const { isLoading, pages, currentPage, countItems } = this.state;
    return (
      <>
        {(isLoading && (
            <LoadingComponent />
        )) || (
          <>
            <Row>
              <Col style={{textAlign: "right"}}>
                <Button
                  className="btn-fill btn-xs"
                  color="primary"
                  type="submit"
                  onClick={()=>this.onClick(0)}
                >
                  Nova página
                </Button>
              </Col>
            </Row>
            <Row>
              <Col xs={2} md={1}>
                Código
              </Col>
              <Col xs={6} md={4}>
                Descrição
              </Col>
              <Col md={3} className="display-none-xs">
                Tipo
              </Col>
              <Col md={2} className="display-none-xs">
                Itens
              </Col>
            </Row>   
            {(pages && (
              <PagesComponent
                pages={pages}
                onClick={this.onClick}
                onDelete={this.onDelete}
                onView={this.onView}
                onDownload={this.onDownload}
                onDuplicate={this.onDuplicate}
                handleOnDragEnd={this.handleOnDragEnd}
              />)
            )}
            {(pages && (
              <PaginationComponent
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={countItems}
                onPageChange={this.onPageChange}
                pageSize={countItems}
              />)
            )}
          </>
          
        )}
      </>
    );
  }
}

export default PagesContainer;
